import notificationChannels from './notificationChannels';

export default function* () {
    yield* [
        ...notificationChannels
    ];
}